<template>
  <div>
    <div class="form-wrap">
      <div class="form-list py-3">

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.email.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[13][2]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="email" value="" placeholder="abc@abc.com" v-model.trim="input.email" @change="$v.input.email.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.email" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[13][1]"/></input-feedback>
            <input-feedback :validate-for-input="$v.input.email" type="email"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[13][2]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.family_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[13][3]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="Yamada" v-model.trim="input.family_name" @change="$v.input.family_name.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.family_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[13][3]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.given_name.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[13][4]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="text" value="" placeholder="Tarou" v-model.trim="input.given_name" @change="$v.input.given_name.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.given_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[13][4]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.password.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[13][5]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="password" value="" placeholder="********" v-model.trim="input.password" @change="$v.input.password.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.password" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[13][5]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- 入力項目-->
        <div class="form-group row" :class="{'has-danger': $v.input.confirm_password.$error}">
          <label class="col-5 col-form-label"><trans-text i18nKey="ui[13][7]"/></label>
          <div class="col-7">
            <input class="form-control transparent-input" type="password" value="" placeholder="********" v-model.trim="input.confirm_password" @change="$v.input.confirm_password.$touch()">
          </div>
          <p class="col-12 pl-4 my-0 form-control-feedback">
            <input-feedback :validate-for-input="$v.input.given_name" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error[13][8]"/></input-feedback>
          </p>
          <div class="col-12 form-hr">
            <hr class="">
          </div>
        </div>

        <!-- フォーム送信UI -->
        <div class="row text-center">
          <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
            <div class="my-2">
              <!--<button type="button" class="btn w-100 btn-lg btn-warning" data-toggle="modal" data-target="#CanNotOperateWithinDemoAlert"><trans-text i18nKey="ui[13][8]"/></button>-->
              <button type="button" class="btn w-100 btn-lg btn-warning" @click="tryForm"><trans-text i18nKey="ui[13][8]"/></button>

            </div>
          </div>
        </div>
        <div class="row text-center">
          <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
            <div class="my-2">
              <router-link tag="button" class="btn w-100 btn-lg btn-default" :to="{ name: 'top', params:{} }">
                <trans-text i18nKey="ui[13][9]"/>
              </router-link>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  import FormPartialBase from 'extends/FormPartialBase.vue'
  import {required,email,minLength,alphaNum,sameAs} from 'systems/validators'

  export default {
    extends:FormPartialBase,
    components: {
    },
    data () {
      return {

        input: {
          email: "",
          family_name: "",
          given_name: "",
          password: "",
          confirm_password: "",
        }
      }
    },
    validations: {
      input: {
        family_name: {
          required
        },
        given_name: {
          required
        },
        email: {
          required,
          email,
        },
        password: {
          required,
          alphaNum,
          minLength: minLength(8),
        },
        confirm_password: {
          required,
          sameAsPassword: sameAs('password'),
        },
      },
    },
    created(){
    },
    methods:{
      tryForm(e){


        //バリデーション
        if(this.$v.input.$invalid){
          this.$v.input.$touch()
          return
        }
        this.$emit('tryForm', this.input)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// PageForm.vue?ec5f5b48